// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Group from "../../resources/layout-and-structure/Group.res.js";
import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as CatalogVariant from "./CatalogVariant.res.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as FieldsetLayoutPanel from "../../resources/layout-and-structure/FieldsetLayoutPanel.res.js";
import * as CatalogVariantEditForm from "./CatalogVariantEditForm.res.js";
import * as CatalogVariantEditFormInputs from "./CatalogVariantEditFormInputs.res.js";

function CatalogVariantEditFormInformationFieldsetPanel(props) {
  let productKind = props.productKind;
  let editionMode = props.editionMode;
  let dispatch = CatalogVariantEditForm.useFormDispatch();
  let match = CatalogVariantEditForm.useFormState().values;
  let bulk = match.bulk;
  let year = match.year;
  let capacityValue = match.capacityValue;
  let capacityUnit = match.capacityUnit;
  let name = match.name;
  let match$1 = React.useState(() => ({
    focused: false,
    modified: false
  }));
  let setNameFieldInteracted = match$1[1];
  let nameFieldInteracted = match$1[0];
  ReactUpdateEffect.use1(() => {
    if (nameFieldInteracted.focused && name !== "") {
      setNameFieldInteracted(prev => ({
        focused: prev.focused,
        modified: true
      }));
    }
  }, [name]);
  ReactUpdateEffect.use1(() => {
    if (bulk) {
      dispatch({
        TAG: "FieldValueChanged",
        _0: "CapacityValue",
        _1: param => {}
      });
    }
  }, [bulk]);
  ReactUpdateEffect.use4(() => {
    if (!nameFieldInteracted.modified) {
      dispatch({
        TAG: "FieldValueChanged",
        _0: "Name",
        _1: param => CatalogVariant.Name.make(productKind, capacityValue, capacityUnit, bulk, year !== undefined && year !== 0 ? year | 0 : undefined)
      });
    }
  }, [
    capacityValue,
    capacityUnit,
    year,
    bulk
  ]);
  return JsxRuntime.jsxs(FieldsetLayoutPanel.make, {
    title: I18n.t("General information"),
    description: I18n.t("By entering a capacity value and a year, the variant name will be automatically generated."),
    children: [
      editionMode ? null : JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(CatalogVariantEditForm.InputToggleSwitch.make, {
            label: I18n.t("Bulk product management") + "  ",
            field: "Bulk"
          }),
          style: {
            alignSelf: "flex-start"
          }
        }),
      JsxRuntime.jsxs(Group.make, {
        children: [
          !bulk && Stdlib_Option.isSome(capacityUnit) ? JsxRuntime.jsx(CatalogVariantEditFormInputs.InputVariantCapacityValueSelect.make, {
              productKind: productKind
            }) : null,
          JsxRuntime.jsx(CatalogVariantEditFormInputs.InputVariantCapacityUnitSelect.make, {
            productKind: productKind,
            disabled: bulk && editionMode
          }),
          productKind === "WINE" || productKind === "SPIRITUOUS" ? JsxRuntime.jsx(CatalogVariantEditFormInputs.InputVariantYear.make, {
              productKind: productKind
            }) : null
        ]
      }),
      JsxRuntime.jsx(CatalogVariantEditForm.InputText.make, {
        field: "Name",
        label: I18n.t("Variant's name"),
        placeholder: bulk ? I18n.t("Bulk by kg") : CatalogVariant.Name.placeholderFromProductKind(productKind),
        onFocus: () => setNameFieldInteracted(prev => ({
          focused: true,
          modified: prev.modified
        }))
      }),
      JsxRuntime.jsxs(Group.make, {
        children: [
          productKind === "WINE" || productKind === "BEER" || productKind === "SPIRITUOUS" ? JsxRuntime.jsx(CatalogVariantEditFormInputs.InputVariantAlcoholVolume.make, {
              productKind: productKind
            }) : null,
          JsxRuntime.jsx(CatalogVariantEditFormInputs.InputVariantPriceLookup.make, {}),
          JsxRuntime.jsx(CatalogVariantEditFormInputs.InputVariantStockKeepingUnit.make, {
            editionMode: editionMode
          }),
          JsxRuntime.jsx(CatalogVariantEditForm.InputText.make, {
            field: "Ean13",
            label: I18n.t("Barcode"),
            placeholder: "3670257725480",
            copyable: true
          }),
          JsxRuntime.jsx(CatalogVariantEditForm.InputText.make, {
            field: "InternalCode",
            label: I18n.t("Internal code"),
            placeholder: "CAB04-750ML-2019",
            copyable: true
          })
        ],
        grid: [
          "50%",
          "50%"
        ]
      })
    ]
  });
}

let make = React.memo(CatalogVariantEditFormInformationFieldsetPanel);

export {
  make,
}
/* make Not a pure module */
